// extracted by mini-css-extract-plugin
export default {"btn":"PrintLink_btn__3qZq+"};